import { DateTime } from "luxon";

export const getDaysInMonthMode = (date: DateTime): DateTime[] =>
  Array(42)
    .fill("")
    .map((_, i) => date.startOf("month").startOf("week").plus({ days: i }));
